export const SET_SKILLS = 'SET_SKILLS';